import { render, staticRenderFns } from "./GridMixed.vue?vue&type=template&id=71c53d40"
import script from "./GridMixed.vue?vue&type=script&lang=js"
export * from "./GridMixed.vue?vue&type=script&lang=js"
import style0 from "./GridMixed.vue?vue&type=style&index=0&id=71c53d40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports